var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { staticClass: "poll-title poll-title--centered" }, [
      _vm._v(_vm._s(_vm._("Які бренди каші для дітей ви вводили?")))
    ]),
    _c(
      "div",
      { staticClass: "poll-checkboxes" },
      [
        _vm._l(_vm.brands, function(item) {
          return _c("div", { staticClass: "poll-checkboxes__el" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.brand,
                  expression: "brand"
                }
              ],
              staticClass: "poll-checkboxes__input",
              attrs: { type: "checkbox", name: "brands", id: item.key },
              domProps: {
                value: item.key,
                checked: Array.isArray(_vm.brand)
                  ? _vm._i(_vm.brand, item.key) > -1
                  : _vm.brand
              },
              on: {
                change: function($event) {
                  var $$a = _vm.brand,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = item.key,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.brand = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.brand = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.brand = $$c
                  }
                }
              }
            }),
            _c(
              "label",
              {
                staticClass: "poll-checkboxes__label",
                attrs: { for: item.key }
              },
              [
                _c("p", { staticClass: "poll-checkboxes__text" }, [
                  _vm._v(" " + _vm._s(item.title))
                ])
              ]
            )
          ])
        }),
        _c("div", { staticClass: "poll-checkboxes__el" }, [
          _c("div", { staticClass: "poll-input" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.other,
                  expression: "other"
                }
              ],
              staticClass: "poll-input__input",
              attrs: {
                type: "text",
                disabled: _vm.isDisabled(),
                name: "other",
                placeholder: _vm._("Вкажіть інший бренд")
              },
              domProps: { value: _vm.other },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.other = $event.target.value
                }
              }
            })
          ])
        ])
      ],
      2
    ),
    _c(
      "button",
      {
        staticClass: "poll-btn",
        class: { "is-disabled": !_vm.brand.length },
        attrs: { href: "" },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.next($event)
          }
        }
      },
      [_vm._v(_vm._s(_vm._("Далі")))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-253d16f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-253d16f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/poll/steps/brands.vue
// module id = 216
// module chunks = 4